<template>
  <tabs parent="task_list">
    <tab
        id="mass_rpc"
        :name="translate('task_list.mass_rpc.title')"
        :href="url+'/mass_rpc'"
    >
      <RPCList />
    </tab>

    <tab
      id="tasks"
      :name="translate('task_list.tasks.title')"
      :href="url+'/tasks'"
    >
      <MainTasks />
    </tab>

    <tab
        id="templates"
        :name="translate('task_list.templates.title')"
        :href="url+'/templates'"
    >
      <RPCTemplates />
    </tab>
  </tabs>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import MainTasks from "./Tabs/Tasks/Index.vue"
import RPCList from './Tabs/MassRPC/Index.vue'
import RPCTemplates from './Tabs/Templates/Templates.vue'

export default {
  name: 'TaskList',
  components:{
    Tab,
    Tabs,
    MainTasks,
    RPCList,
    RPCTemplates
  },
  data () {
    return {
      // load: true,
      // role_list: [],
      // permission_list: []
    }
  },


  computed: {
    url () { return '/task_list' }
  },

  created () {
    // if (this.$store.getters.getPermissions?.editRbac === true){
    //   this.get_roles_list()
    // }
  },

  methods: {
    // get_roles_list () {
    //   this.$http.v1.getAllRoles((response) => {
    //
    //     let role_list = {}
    //     for (let role in response.data.roles) {
    //       role_list[role] = response.data.roles[role]
    //       role_list[role].permissions = response.data.roles[role].permissions.sort()
    //     }
    //     this.role_list = role_list
    //
    //     this.permission_list = response.data.permissions
    //   })
    // },
  },
}
</script>
